import { useCallback, useEffect, useRef, useState } from "react";
import { IoIosContact } from "react-icons/io";
import Select from 'react-select'
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useStore } from "react-redux";
import { IoMdShare } from "react-icons/io";

import { getAllNotification, getNotificationsUnified } from "../../../../../redux/actions/notification";
import { toast } from "../../../../CommonComponents/ToastComponent/toast";
import { formatRelativeDate } from "../../../../../services/helper";
import { getInCallsListSuppliers, getRecordingUrl, linkVoicemailToVendor, shareCall } from "../../../../../redux/actions/caller";
import { colors } from "../../../../../utils/constants/colors";
import { Loader } from "rsuite";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import QaNotesModal from "../../../../QualityComponent/modals/qa-notes-modal";
import { CONSTANTS } from "../../../../../utils/constants/constants";

const MissedCallDetail = () => {
    const store = useStore().getState()
    
    const { auth: { user } } = store
    const location = useLocation()
    const dispatch = useDispatch()
    const abortControllerRef = useRef(null)

    const tmpCallSid = location.search?.split('=')[1]

    const [missedCallDetails, setMissedCallDetails] = useState(null)
    const [audioUrl, setAudioUrl] = useState(null)
    const [listSuppliersInCall, setListSuppliersInCall] = useState([])
    const [selectedListSupplier, setSelectedListSupplier] = useState({})
    const [showSuppliers, setShowSuppliers] = useState(false)
    const [linkedSupplierName, setLinkedSupplierName] = useState('Unknown')
    const [loader, setLoader] = useState('Unknown')
    const [showShareVoicemail, setShowShareVoicemail] = useState(false)

    const getDetailsForUnReadMissedCall = useCallback(async () => {
        try {
            setLoader(true)
            abortControllerRef.current = new AbortController();
            const listSuppliersInCalls = await dispatch(getInCallsListSuppliers([])).then((res) => res).catch(err => {
                if (err) {
                    toast.show({
                        title: 'Danger',
                        description: 'Unable To Get ListSuppliers',
                    });
                }
            })
            let formatedListSuppliers = listSuppliersInCalls?.map((listSuppliersInCall) => {
                return {
                    label: listSuppliersInCall?.suppliername,
                    value: listSuppliersInCall?.id
                }
            })

            const details = await dispatch(getNotificationsUnified({ offset: null, limit: null, type:'missedCallDetails', callSid: tmpCallSid, filterValue: '', searchTerm: '' })).then(res => res).catch(err => {
                if (err) {
                    toast.show({
                        title: 'Danger',
                        description: 'Unable To Get Details',
                    });
                }
            })

            const missedCall = details?.results?.[0];

            const tmpCallRecordingSid = missedCall?.callRecordingSid;
            if (!tmpCallRecordingSid) return;

            const response = await dispatch(getRecordingUrl(tmpCallRecordingSid)).then(res => res).catch(err => {
                if (err) {
                    toast.show({
                        title: 'Danger',
                        description: 'Unable To Get Recording Details',
                    });
                }
            })

            const blobUrl = URL.createObjectURL(new Blob([response], { type: 'audio/mpeg' }));
            setLoader(false)
            setMissedCallDetails(missedCall);
            setListSuppliersInCall(formatedListSuppliers)
            setAudioUrl(blobUrl);
        } catch (err) {
            toast.show({
                title: 'Danger',
                description: 'Unable To Get Missed Call or Recording Details',
            });
        }
    }, []);

    const getListSuppliersInCallsHandler = async () => {
        const listSuppliersInCalls = await dispatch(getInCallsListSuppliers([])).then((res) => res).catch(err => {
            if (err) {
                toast.show({
                    title: 'Danger',
                    description: 'Unable To Get ListSuppliers',
                });
            }
        })
        let formatedListSuppliers = listSuppliersInCalls?.map((listSuppliersInCall) => {
            return {
                label: listSuppliersInCall?.suppliername,
                value: listSuppliersInCall?.id
            }
        })

        setListSuppliersInCall(formatedListSuppliers)
        setShowSuppliers(true)
    }

    const linkToListSupplierHandler = (e) => {
        setSelectedListSupplier(e)
    }

    const onCancel = () => {
        setShowSuppliers(false)
    }

    const onLinkSupplier = async () => {
        const result = await dispatch(linkVoicemailToVendor(selectedListSupplier?.value, missedCallDetails?.callSid)).then(res => res).catch(err => {
            if (err) {
                toast.show({
                    title: 'Danger',
                    description: 'Unable To Link Supplier',
                });
            }
        })

        if (result?.message === CONSTANTS.API_RES_MESSAGE.LINK_TO_VENDOR_SUCCESS) {
            setLinkedSupplierName(selectedListSupplier?.label)
        }
    }

    const onShareVoicemail = () => {
        setShowShareVoicemail(true)
    }

    const handleVoicemailShare = (notes) => {
        let userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
        let editorContent = notes ? draftToHtml(convertToRaw(notes.getCurrentContent())) : '';
        let regex = /<a .*?>/g
        const emailsArray = [...editorContent.matchAll(regex)]
        let emails = []

        emailsArray && emailsArray.map((item) => {
            let hrefRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g
            let valueRegex = /<a\s+(?:[^>]*?\s+)?data-value="([^"]*)"/g
            const hrefArray = [...item[0].matchAll(hrefRegex)]
            const valueArray = [...item[0].matchAll(valueRegex)]
            if (hrefArray.length && valueArray.length) {
                const href = hrefArray?.[0]?.[1]
                const value = valueArray?.[0]?.[1]
                emails.push({ email: href.replaceAll('https://', ''), name: value.replaceAll('https://', '') })
            }
        })
        if (!emails || emails?.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'Please add user email to share the call!',
            })
            return
        }

        dispatch(shareCall(
            editorContent,
            userName,
            emails,
            missedCallDetails?.callSid,
            null,
            true,
            'missedCallDetail'
        )).then(() => {
            setShowShareVoicemail(false)
        }).catch((err) => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Share Voicemail',
            })
        })
    }

    useEffect(() => {
        getDetailsForUnReadMissedCall()
        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort()
            }
        }
    }, [])

    let time = formatRelativeDate(missedCallDetails?.createdAt)
    
    return (
        <div className="container-fluid border h-100 d-flex align-items-center justify-content-center flex-column p-4 row-gap-3 column-gap-3 border" style={{ borderRadius: '6px' }}>
            {loader ? <div className="d-flex justify-content-center align-items-center">
                <Loader />
            </div> : <div className="w-25 d-flex flex-column row-gap-5">
                <div className="w-100   d-flex justify-content-center column-gap-4" style={{ height: '70px' }}>
                    <div className="d-flex  column-gap-3 align-items-center">
                        <IoIosContact size={70} />
                        <div className="">
                            <p className="fw-bold text-black fs-4 p-0 m-0">{missedCallDetails?.listSupplierId ? missedCallDetails?.suppliername : 'Unknown'}</p>
                            <div className="d-flex column-gap-5">
                                <p className="text-black fs-4 p-0 m-0">{missedCallDetails?.externalNumber}</p>
                                <p className="text-black fs-4 p-0 m-0">{time}</p>
                            </div>
                        </div>
                        <div className="border">
                        </div>
                    </div>
                </div>
                <div className=" w-100 row-gap-5 d-flex flex-column align-items-center column-gap-4 row-gap-3" style={{ height: '300px' }}>
                    <div className="d-flex w-100 align-items-center column-gap-5">
                        <audio key={audioUrl} controls src={audioUrl} />
                        <IoMdShare size={25} style={{ cursor: 'pointer' }} onClick={onShareVoicemail} />
                    </div>

                    {!showSuppliers && !missedCallDetails?.listSupplierId && <div className="d-flex">
                        <button
                            className="report_small_button_success px-4"
                            style={{ width: 'auto' }}
                            onClick={getListSuppliersInCallsHandler}
                        >
                            Link To Supplier
                        </button>
                    </div>}
                    {showSuppliers && <div className="d-flex w-100 justify-content-center">
                        <Select
                            className={`w-100 fs-4`}
                            options={listSuppliersInCall}
                            value={selectedListSupplier}
                            onChange={(e) => linkToListSupplierHandler(e)}
                        />
                    </div>}
                    {showSuppliers && <div className="d-flex column-gap-3">
                        <button className="report_small_button_grey" onClick={onCancel}>Cancel</button>
                        <button className="report_small_button_success" onClick={onLinkSupplier}>Ok</button>
                    </div>}
                </div>
            </div>}
            <QaNotesModal
                show={showShareVoicemail}
                onClose={() => { setShowShareVoicemail(false) }}
                onDone={handleVoicemailShare}
                title='Share Voicemail'
                size='md'
                isShareCallModal={true}
            />
        </div>
    )
}

export default MissedCallDetail